import React from 'react';
import styled from 'styled-components';

type Props = {
  children: React.ReactNode,
};

const BaseLabel = ({children}: Props) => (
  <Label>
    <span>{children}</span>
  </Label>
);

const Label = styled.div`
  font-size: 16px;
  color: #ef5350;
  letter-spacing: 1px;
  margin-bottom: 40px;

  span {
    border-bottom: solid 3px #ef5350;
    padding-bottom: 11px;
  }
`;

export {BaseLabel};
